export default "__VITE_ASSET__B_cfLRr___"